import { HttpMethods, makeRequest } from '../helpers/http.helper';
import {
  TruckRequest,
  UpdateTruckRequest,
  TruckQueryParams,
  DriverRegisterRequest,
  AssignDriverRequest,
  DriverDetails,
} from '../types/transportation.type';

export interface GenericDriverDetailsResponse {
  result: DriverDetails;
  error?: { message?: string; code?: string } | null;
  response?: { message?: string; code?: string } | null;
}

// Trucks
export const getTrucks = (params: TruckQueryParams) => {
  const { organization_id, ...otherParams } = params;
  return makeRequest({
    url: `/truck/${organization_id}`,
    method: HttpMethods.GET,
    params: otherParams,
  });
};

export const getTruck = (truckId: string) => {
  return makeRequest({
    url: `/truck/detail/${truckId}`,
    method: HttpMethods.GET,
  });
};

export const createTruck = (truck: TruckRequest) => {
  return makeRequest({
    url: '/truck',
    method: HttpMethods.POST,
    data: truck,
  });
};

export const updateTruck = (truckId: string, truck: UpdateTruckRequest) => {
  return makeRequest({
    url: `/truck/${truckId}`,
    method: HttpMethods.PUT,
    data: truck,
  });
};

export const deleteTruck = (truckId: string) => {
  return makeRequest({
    url: `/truck/${truckId}`,
    method: HttpMethods.DELETE,
  });
};

// Driver endpoints
export const registerDriver = (data: DriverRegisterRequest) => {
  return makeRequest({
    url: '/truck/driver/register',
    method: HttpMethods.POST,
    data,
  });
};

export const assignDriverToTruck = (truckId: string, data: AssignDriverRequest) => {
  return makeRequest({
    url: `/truck/${truckId}/assign-driver`,
    method: HttpMethods.PUT,
    data,
  });
};

export const unassignDriverFromTruck = (truckId: string) => {
  return makeRequest({
    url: `/truck/${truckId}/unassign-driver`,
    method: HttpMethods.PUT,
  });
};

export const getDriverTruck = (driverId: string) => {
  return makeRequest({
    url: `/truck/driver/${driverId}/truck`,
    method: HttpMethods.GET,
  });
};

export const getDriverDetails = (driverId: string) => {
  return makeRequest({
    url: `/truck/driver/${driverId}`,
    method: HttpMethods.GET,
  }) as Promise<GenericDriverDetailsResponse>;
}; 